import { useTranslation } from 'react-i18next';
import { FiGlobe } from 'react-icons/fi';
import MenuDesplegable from './MenuDesplegable';

const IDIOMAS = [
    { codigo: 'es', nombre: 'Español' },
    { codigo: 'en', nombre: 'English' }
];

/**
 * El selector de idioma.
 *
 * Se abría solo al pasar el ratón, así que en un móvil no había manera de
 * cambiar de idioma. Y estaba pintado con `bg-white` y `text-gray-*` sin
 * ninguna variante `dark:`, de modo que sobre la cabecera oscura el botón se
 * veía apagado y el menú se abría en blanco, fuera del tema de la aplicación.
 */
export default function LanguageSwitcher() {
    const { i18n, t } = useTranslation();
    const actual = i18n.language?.split('-')[0] || 'es';

    return (
        <MenuDesplegable
            etiqueta={t('common.language')}
            anchura="w-36"
            claseBoton="flex items-center gap-1 p-2 rounded-lg text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
            boton={
                <>
                    <FiGlobe className="w-5 h-5" />
                    <span className="text-sm font-medium uppercase">{actual}</span>
                </>
            }
        >
            {(cerrar) =>
                IDIOMAS.map(({ codigo, nombre }) => (
                    <button
                        key={codigo}
                        type="button"
                        role="menuitem"
                        onClick={() => {
                            i18n.changeLanguage(codigo);
                            cerrar();
                        }}
                        className={`block w-full text-left px-4 py-2 text-sm ${
                            actual === codigo
                                ? 'bg-primary-50 dark:bg-slate-700 text-primary-600 dark:text-primary-400 font-medium'
                                : 'text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700'
                        }`}
                    >
                        {nombre}
                    </button>
                ))
            }
        </MenuDesplegable>
    );
}
